import { useMutation } from "react-query";
import { addOfficeStatusDetails } from "../../../../../actions/Utilities/OfficeStatusDetails";
import { toast } from "components/toastNotification";
import { IOfficeStatusDetails } from "../types";
import { useRecoilState, useSetRecoilState } from "recoil";
import { addStateOfficeStatusDetails, officeStatusDetailsReFetching } from "../atoms/atoms";

const useAddOfficeStatusDetails = () => {
  const setIsAddState = useSetRecoilState(addStateOfficeStatusDetails);
  const [isReFetching, setIsReFetching] = useRecoilState(
    officeStatusDetailsReFetching
  );

  const { mutate } = useMutation(
    (NewData: IOfficeStatusDetails) => addOfficeStatusDetails(NewData),
    {
      onSuccess: (res: any) => {
        if (typeof res == "object") {
          toast.fire(
            "Adding Office Status Detail failed", 
            `Error: ${res.Message}`, 
            "error"
          );
        }
        else {
          if (res === "Success") {
            toast.fire("Success", "Office Status Detail Added Successfully", "success");
          } 
          else if (res === "Operation Failed!") {
              toast.fire("Adding Office Status Detail failed", `Server Error: ${res}`, "error");
          } 
          else if (res === "The data already exists!") {
              toast.fire("Adding Office Status Detail failed", `Duplication Error: ${res}`, "error");
          } 
          else if (res.includes("Notification insert Failed")) {
              toast.fire("Success", `Office Status Detail Added Successfully, BUT ${res}`, "warning");
          } 
          else if (res.includes("Action object")) {
              toast.fire("Adding Office Status Detail failed", `Error: ${res}`, "error");
          } 
        }
        
        // Redirect to View
        setIsAddState(false);
        
        // ReFetch Data
        setIsReFetching(isReFetching ? false : true);
      },

      onError: (error: any) => {
        toast.fire("Add Office Status Detail failed", `Error: ${error}`, "error");
      },
    }
  );

  return mutate;
};
export default useAddOfficeStatusDetails;
